const hrcQuestionnaireEnum = [
  { label: "Option 1", value: "Yes" },
  { label: "Option 2", value: "No" },
];

export default hrcQuestionnaireEnum;

const hrcQuestionnaireEnum2 = [
  { label: "Option 1", value: "Employment" },
  { label: "Option 2", value: "Investment income" },
  { label: "Option 3", value: "Rental income" },
  { label: "Option 4", value: "Savings" },
  { label: "Option 5", value: "Allowance(s)" },
  { label: "Option 6", value: "Others (please specify)" },
];

export const hrcQuestion4 = hrcQuestionnaireEnum2;

const hrcQuestionnaireEnum3 = [
  { label: "Option 1", value: "Membership privileges" },
  { label: "Option 2", value: "Payment card" },
  { label: "Option 3", value: "Product financing" },
  { label: "Option 4", value: "Others (please specify)" },
];

export const hrcQuestion6 = hrcQuestionnaireEnum3;
